/** @format */
import Master from '../Layouts/Master';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';

const validationSchema = Yup.object().shape({
	name: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواندبیشتر از 190 کاراکتر باشد'),
});

const CreateOrganizer = () => {
	const navigate = useNavigate();
	const [submitFormLoading, setSubmitFormLoading] = useState(false);

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.post(
			'/organizer',
			values,
			(res) => {
				success('برگزار کننده با موفقیت ایجاد شد');
				navigate('/panel/organizer', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return (
		<Master>
			<Formik
				initialValues={{
					name: '',
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='d-flex flex-column border rounded p-2 mt-3'>
							<div className='w-100 form-group d-flex flex-row'>
								<div className='w-100 d-flex flex-column mt-1 mx-2'>
									<label>عنوان برگزار کننده</label>
									<input
										name='name'
										value={values.name}
										onChange={handleChange}
										type='text'
										className='form-control'
									/>
									<ErrorMessage error={errors.name} />
								</div>
							</div>
						</div>
						<div className='d-flex flex-row justify-content-end'>
							<button className='btn btn-info btn-sm f-14'>
								{submitFormLoading ? (
									<div
										className='spinner-border spinner-border-sm text-white mb-1'
										role='status'></div>
								) : (
									'ثبت برگزار کننده'
								)}
							</button>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default CreateOrganizer;
